module.exports = __webpack_public_path__ + "img/battlefield-2042-polaris-logo.f43e9932.png";